import { UndoActionBuffer } from './UndoActionBuffer';
import { UndoEvent } from './UndoEvent';
import { EventSlot } from '../events/EventSlot';
import { UndoAction } from './UndoAction';
import { UndoMark } from './UndoMark';


export default class UndoManager
{
  _maxUndos:number = 10;
  _actionBuffers:Array<UndoActionBuffer> = [];
  _position:number = -1;
  _mark:any = null;
  _locked:boolean = false;
  readonly onChange:EventSlot<UndoEvent> = new EventSlot<UndoEvent>();

  _getDebugInfo():string
  {
    var debugInfo = this._getDebugMeta();
    return JSON.stringify(debugInfo,null,2);
  }
  
	_getDebugMeta():any
	{
		var debugInfo:any =
		{
			numUndos:this.numUndos,
			undos:[],
			numRedos:this.numRedos,
			redos:[]
		}

		for ( var i = 0; i < this.numUndos; i++ )
		{
			debugInfo.undos.push( this._actionBuffers[i]._undoHTML );
		}

		for ( var i = 0; i < this.numRedos; i++ )
		{
			var index = this.numUndos + i;
			if ( index < this._actionBuffers.length )
			{
				debugInfo.redos.push( this._actionBuffers[index]._redoHTML );
			}

		}

		return debugInfo;
	}
  
  _lock()
  {
    this._locked = true;
  }
  
  _unlock()
  {
    this._locked = false;
  }
  
  isLocked()
  {
    return this._locked;
  }
  
  get numUndos()
	{
	  return this._position + 1;
	}

  get	numRedos()
	{
	  var actionLength = this._actionBuffers.length;
	  return ( actionLength - this._position ) - 1;
	}
  
  _dispatchChange()
  {
    //console.log( "CHANGE" );
    this.onChange.dispatch( new UndoEvent() );
  }
  
  async commit( undoAction:UndoAction, useRedo:boolean = true ):Promise<void>
  {
    if ( this.isLocked() )
    {
      console.log("Locked State Error on Commit", undoAction);
      throw Error("Locked State");
    }
    
    this._lock();
    
    useRedo = useRedo === true;
    
    while ( this.numRedos > 0 )
	  {
	    var redoActionBuffer = this._actionBuffers.pop();
      redoActionBuffer.release();
	  }
    
    this._position++;
    var newActionBuffer = new UndoActionBuffer( undoAction.undoInfoHTML(), undoAction.redoInfoHTML(), [undoAction] );
    this._actionBuffers.push(newActionBuffer);
    
    if ( this._actionBuffers.length > this._maxUndos )
	  {
	    var undoActionBuffer = this._actionBuffers.shift();
      undoActionBuffer.release();
      this._position--;
	  }
        
    if ( useRedo )
    {      
      await newActionBuffer.redo();
    }
    
    this._dispatchChange();
    this._unlock();

    return Promise.resolve();
    
  }
  
  async undo():Promise<void>
  {
    if ( this.isLocked() )
    {
      console.log("Locked State Error on Undo");
      throw Error("Locked State");
    }
    
    this._lock();
    
    if ( this.numUndos > 0 )
    {             
      if ( this._actionBuffers[ this._position ] === undefined )
      {
        console.log("pos",this._position,this._actionBuffers)
      }
      await this._actionBuffers[ this._position ].undo();

      this._position--;
      this._dispatchChange();  
    }

    this._unlock();
    return Promise.resolve();
    
  }
  
  async redo():Promise<void>
  {
    if ( this.isLocked() )
    {
      console.log("Locked State Error on Undo");
      throw Error("Locked State");
    }

    this._lock();
    
    if ( this.numRedos > 0 )
    {
      this._position++;
      
      await this._actionBuffers[ this._position ].redo();
      this._dispatchChange();
    }
    
    this._unlock();
    return Promise.resolve();
    
  }
  
  mark( undoInfo:string, redoInfo:string ):UndoMark
  {
    if ( this._mark === null )
    {
      this._mark = new UndoMark( undoInfo, redoInfo, this._position );
      return this._mark;
    }    
    
    return undefined;
  } 
  
  compress( mark:UndoMark ):void
  {      
    if ( this._mark === mark )
    {
      if ( this.isLocked() )
      {
        console.log("Locked State Error on Compress");
        throw Error("Locked State");
      }
      this._lock();
      
      this._mark = null;
      var numActions = this._position - mark.position;
      this._compressActions( numActions, mark.undoInfo, mark.redoInfo );
      
      this._unlock();
      
    }
  }
  
  _compressActions( numActions:number, undoInfo:string, redoInfo:string )
	{
		if ( this.numUndos >= numActions && this.numRedos === 0 )
		{
			var start = this._position - numActions + 1;
      
      var compressedActions:Array<any> = [];
      for ( var i=0; i < numActions; i++)
			{
				var actions = this._actionBuffers[ i + start]._actions;
				compressedActions = compressedActions.concat(actions);
			}
      
      var compressedActionBuffer = new UndoActionBuffer( undoInfo, redoInfo, compressedActions);
			this._position -= (numActions-1);
			this._actionBuffers.splice( start, numActions, compressedActionBuffer);
		}
		else
		{
      console.log("ERROR WHILE COMPRESSING: ");
		}
	}
}